import angular from 'angular';
import matchCommissionModal from './matchCommissionModal';

export default angular
  .module('components.matchCommissionModal', [])
  .component('matchCommissionModal', matchCommissionModal).name;
